/* hn-notify — state-7 Notify-Me capture → Klaviyo (the Stoq replacement, capture side).
   Back-in-stock subscription per variant + list opt-in per checked boxes.
   Channel separation (memory feedback_klaviyo_channel_separation): email list always
   when the email box is checked; SMS consent ONLY when the SMS box is checked.
   Config comes from data attrs on <html> injected by layout/theme.liquid:
   data-hn-klaviyo-company, data-hn-klaviyo-email-list, data-hn-klaviyo-sms-list. */
(function () {
  'use strict';

  var CFG = {
    company: document.documentElement.getAttribute('data-hn-klaviyo-company') || '',
    emailList: document.documentElement.getAttribute('data-hn-klaviyo-email-list') || '',
    smsList: document.documentElement.getAttribute('data-hn-klaviyo-sms-list') || ''
  };

  function post(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(CFG.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-04-15' },
      body: JSON.stringify(payload)
    });
  }

  function backInStock(variantId, email, phone, wantsSms) {
    var channels = ['EMAIL'];
    var profileAttrs = { email: email };
    if (wantsSms && phone) {
      channels.push('SMS');
      profileAttrs.phone_number = phone;
    }
    return post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: channels,
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
          }
        }
      }
    });
  }

  function listSubscribe(listId, email, phone, smsConsent) {
    var attrs = { email: email };
    var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (smsConsent && phone) {
      attrs.phone_number = phone;
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    attrs.subscriptions = subscriptions;
    return post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: { profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  function normalizePhone(raw) {
    var digits = (raw || '').replace(/[^\d+]/g, '');
    if (!digits) return '';
    if (digits[0] !== '+') {
      if (digits.length === 10) digits = '+1' + digits;
      else if (digits.length === 11 && digits[0] === '1') digits = '+' + digits;
      else digits = '+' + digits;
    }
    return digits;
  }

  function handle(unit) {
    var btn = unit.querySelector('[data-hn-notify-submit]');
    var msg = unit.querySelector('[data-hn-notify-msg]');
    if (!btn || unit.getAttribute('data-hn-bound')) return;   // re-init after a variant swap must not double-bind
    unit.setAttribute('data-hn-bound', '1');
    btn.addEventListener('click', function () {
      var email = (unit.querySelector('[name="hn-notify-email"]') || {}).value || '';
      var phone = normalizePhone((unit.querySelector('[name="hn-notify-phone"]') || {}).value || '');
      var emailOptIn = (unit.querySelector('[name="hn-notify-email-optin"]') || {}).checked;
      var smsOptIn = (unit.querySelector('[name="hn-notify-sms-optin"]') || {}).checked;
      var variantId = unit.getAttribute('data-variant-id');

      msg.hidden = true;
      msg.classList.remove('is-error');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        msg.textContent = 'Please enter a valid email address.';
        msg.classList.add('is-error');
        msg.hidden = false;
        return;
      }
      if (smsOptIn && !phone) {
        msg.textContent = 'Add a mobile number to get text updates, or uncheck the text option.';
        msg.classList.add('is-error');
        msg.hidden = false;
        return;
      }
      if (!CFG.company) {
        msg.textContent = 'Sign-up is temporarily unavailable. Please try again later.';
        msg.classList.add('is-error');
        msg.hidden = false;
        return;
      }

      btn.disabled = true;
      var work = [backInStock(variantId, email, phone, smsOptIn)];
      if (emailOptIn && CFG.emailList) work.push(listSubscribe(CFG.emailList, email, '', false));
      if (smsOptIn && phone && CFG.smsList) work.push(listSubscribe(CFG.smsList, email, phone, true));

      Promise.all(work)
        .then(function (responses) {
          var failed = responses.some(function (r) { return !r.ok && r.status !== 202; });
          if (failed) throw new Error('subscribe failed');
          unit.querySelectorAll('input, button').forEach(function (el) { el.disabled = true; });
          msg.textContent = 'You’re on the list — we’ll let you know the moment it’s back.';
          msg.hidden = false;
        })
        .catch(function () {
          btn.disabled = false;
          msg.textContent = 'Something went wrong — please try again.';
          msg.classList.add('is-error');
          msg.hidden = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-hn-notify]').forEach(handle);
  }
  window.hnNotifyInit = init;   // hn-availability's variant-swap script re-binds a freshly rendered unit
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
